import { Box, Container, Typography, Stack, Grid } from '@mui/material';
import { SUPPORT_EMAIL } from '../../lib/constants';
import { navigate } from '../../lib/navigation';
import LogoMark from '../../components/LogoMark';

function Footer() {
  return (
    <Box component="footer" sx={{ borderTop: 1, borderColor: 'divider', bgcolor: 'background.paper' }}>
      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Grid container spacing={4}>
          <Grid size={{ xs: 12, sm: 4 }}>
            <LogoMark />
            <Typography color="text.secondary" sx={{ mt: 2, maxWidth: 280 }}>
              UGC opportunities and a professional profile that helps creators show brands what they can do.
            </Typography>
            <Stack direction="row" spacing={2} sx={{ mt: 2.5 }}>
              <Box
                component="a"
                href="https://www.instagram.com/creatorcv.app/"
                target="_blank"
                rel="noreferrer"
                aria-label="CreatorCV on Instagram"
                sx={{ display: 'inline-flex' }}
              >
                <Box component="img" src="/Instagram_logo.svg" alt="" sx={{ width: 24, height: 24 }} />
              </Box>
            </Stack>
          </Grid>
          <Grid size={{ xs: 12, sm: 4 }}>
            <Typography variant="subtitle2" fontWeight={700} gutterBottom>
              Contact
            </Typography>
            <Box
              component="button"
              onClick={() => navigate('/contact')}
              sx={{ display: 'block', border: 0, background: 'none', p: 0, cursor: 'pointer', font: 'inherit', color: 'text.secondary' }}
            >
              Contact us
            </Box>
            <Box
              component="a"
              href={`mailto:${SUPPORT_EMAIL}`}
              sx={{ display: 'block', mt: 0.5, color: 'text.secondary', textDecoration: 'none', '&:hover': { color: 'primary.main' } }}
            >
              {SUPPORT_EMAIL}
            </Box>
          </Grid>
        </Grid>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 5 }}>
          © {new Date().getFullYear()} CreatorCV. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
}

export default Footer;
